import React from "react";
import styleHome from "./Home.module.css";
import logo from "../../../assets/img/logo.png";
import Tax_bro from "../../../assets/img/Tax-bro.png";
import Wallet_pana from "../../../assets/img/Wallet-pana.png";
import Documents_amico from "../../../assets/img/Documents-amico.png";
import Saving_money_rafiki from "../../../assets/img/Saving-money-rafiki.png";
import freepik_Balance_inject_64 from "../../../assets/img/freepik--Balance--inject-64.png";
import support from "../../../assets/img/freepik-export-20240708123702oglS.png";
import dispute from "../../../assets/img/sponsorship.png";
import manMask from "../../../assets/img/manMask.png";
import { Link, Navigate } from "react-router-dom";
import Lottie from "react-lottie";
import cityBuildings from "../../../lotties/city-buildings.json";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../../contexts/AuthProvider";
import UseAuth from "../../../hooks/UseAuth";
import { logout } from "../../../adapters/apis/auth/auth";
import Cookies from "js-cookie";
import Footer from "../../../layouts/footer/Footer";

import { get } from "../../../adapters/xhr/api";

const Home = () => {
  const { auth } = UseAuth();
  const { setAuth } = useContext(AuthContext);
  const user_context = useContext(AuthContext);
  const use_navigate = useNavigate();
  const navigate = useNavigate();

  useEffect(() => {
    checkVerfication();
  }, []);

  const checkVerfication = async () => {
    try {
      const response = await get("api/user/verifications", {}, true);
      const isFullyVerified = response?.data?.fully_verified;
      if (!isFullyVerified) {
        navigate("/DisabledHome");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleLogout = async () => {
    // Optionally: disable logout button here via local state if needed

    try {
      await logout();
    } catch (e) {
    } finally {
      setAuth({}); // clear context

      // Remove tokens and user info
      Cookies.remove("auth-token");
      Cookies.remove("refresh-token");
      Cookies.remove("user-name");
      // Cookies.remove("phone_verified");
      // Cookies.remove("ocr_verified");
      Cookies.remove("idle-timeout-mins");

      // Support-page data you were storing
      localStorage.removeItem("user-full-name");

      try {
        localStorage.setItem("__logout_at", String(Date.now()));
      } catch {}

      navigate("/login");
    }
  };

  useEffect(
    function () {
      if (user_context.user) {
        return use_navigate("/tax-declaration/list-data");
      }
    },
    [user_context.user, use_navigate],
  );

  const defaultOptions = {
    loop: true,
    autoplay: true,
    speed: 1,
    animationData: cityBuildings,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <>
      <section className={styleHome["home-section"]}>
        <div className={`${styleHome.container}`}>
          <div className="d-flex justify-content-between align-items-center flex-lg-row flex-column mb-5">
            <div className="mx-auto mt-sm-5 mt-auto">
              <div
                className={`${styleHome["home-section-logo"]} d-flex justify-content-evenly flex-lg-row flex-md-column align-items-center gap-1 mb-5`}
              >
                <Link to="/home" id="home_button">
                  <img
                    src={logo}
                    alt=""
                    width="100"
                    height="100"
                    className="d-inline-block align-text-center"
                  />
                </Link>
                <h3 className="text-center fw-bolder mt-2">
                  وزارة المالية
                  <span className="d-block mt-2">مصلحة الضرائب العقارية</span>
                </h3>
              </div>
              <div className="home-section-services">
                <Link
                  id="tax_declaration_button_home"
                  to="/tax-declaration/list-data"
                  className={styleHome["services-link"]}
                >
                  <div className={`${styleHome.info} info mt-3`}>
                    <div className="box d-flex justify-content-end gap-3 align-items-center border border-primary rounded-4">
                      <img
                        src={Tax_bro}
                        className={`${styleHome.serviceImg} pt-2 pb-2 ps-3 pe-3`}
                        alt="Tax_bro"
                      />
                      <div className="flex-grow-1">
                        <h3 className="text-center mb-0">الإقرار الضريبى</h3>
                      </div>
                    </div>
                  </div>
                </Link>
                <div className={`${styleHome.info} info mt-3`}>
                  <Link
                    id="Electronic_payment_button_home"
                    to="/settlement-account-debt"
                    className={styleHome["services-link"]}
                  >
                    <div className="box d-flex justify-content-end gap-3 align-items-center border border-primary rounded-4">
                      <img
                        src={Wallet_pana}
                        className={`${styleHome.serviceImg} pt-2 pb-2 ps-3 pe-3`}
                        alt="Wallet_pana"
                      />
                      <div className="flex-grow-1">
                        <h3 className="text-center mb-0">
                          سداد مديونيات بعلم المكلف
                        </h3>
                      </div>
                    </div>
                  </Link>
                </div>

                <div className={`${styleHome.info} info mt-3`}>
                  <Link
                    id="my-debts"
                    to="/my-debts"
                    className={styleHome["services-link"]}
                  >
                    <div className="box d-flex justify-content-end gap-3 align-items-center border border-primary rounded-4">
                      <img
                        src={Wallet_pana}
                        className={`${styleHome.serviceImg} pt-2 pb-2 ps-3 pe-3`}
                        alt="Wallet_pana"
                      />
                      <div className="flex-grow-1">
                        <h3 className="text-center mb-0">مديونياتي</h3>
                      </div>
                    </div>
                  </Link>
                </div>

                <div className={`${styleHome.info} info mt-3`}>
                  <Link
                    id="Electronic_payment_button_home"
                    // to="/online-payment/list-payment"
                    to="/coming-soon?s=payment"
                    className={styleHome["services-link"]}
                  >
                    <div className="box d-flex justify-content-end gap-3 align-items-center border border-primary rounded-4">
                      <img
                        src={Wallet_pana}
                        className={`${styleHome.serviceImg} pt-2 pb-2 ps-3 pe-3`}
                        alt="Wallet_pana"
                      />
                      <div className="flex-grow-1">
                        <h3 className="text-center mb-0">
                          الدفع الإلكتروني للوحدات المميكنة
                        </h3>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className={`${styleHome.info} info mt-3`}>
                  <Link
                    id="official_reveal_button_home"
                    to="/coming-soon?s=statement"
                    className={styleHome["services-link"]}
                  >
                    <div className="box d-flex justify-content-end gap-3 align-items-center border border-primary rounded-4">
                      <img
                        src={Documents_amico}
                        className={`${styleHome.serviceImg} pt-2 pb-2 ps-3 pe-3`}
                        alt="Documents_amico"
                      />
                      <div className="flex-grow-1">
                        <h3 className="text-center mb-0">الكشف الرسمى</h3>
                      </div>
                    </div>
                  </Link>
                </div>
                {/* <div className={`${styleHome.info} info mt-3`}>
                  <Link
                    id="tax_exemption_button_home"
                    to="/coming-soon"
                    className={styleHome["services-link"]}
                  >
                    <div className="box d-flex justify-content-end gap-3 align-items-center border border-primary rounded-4">
                      <img
                        src={Saving_money_rafiki}
                        className={`${styleHome.service-img} pt-2 pb-2 ps-3 pe-3`}
                        alt="Saving_money_rafiki"
                      />
                      <div className="flex-grow-1">
                        <h3 className="text-center mb-0">الإعفاء الضريبى</h3>
                      </div>
                    </div>
                  </Link>
                </div> */}
                <div className={`${styleHome.info} info mt-3`}>
                  <Link
                    id="tax_appeal_button_home"
                    // to="/tax-appeal/list-data"
                    to="/coming-soon?s=appeal"
                    className={styleHome["services-link"]}
                  >
                    <div className="box d-flex justify-content-end gap-3 align-items-center border border-primary rounded-4">
                      <img
                        src={freepik_Balance_inject_64}
                        className={`${styleHome.serviceImg} pt-2 pb-2 ps-3 pe-3`}
                        alt="freepik_Balance_inject_64"
                      />
                      <div className="flex-grow-1">
                        <h3 className="text-center mb-0">الطعن الضريبى</h3>
                      </div>
                    </div>
                  </Link>
                </div>

                <div className={`${styleHome.info} info mt-3`}>
                  <Link
                    id="dispute_button_home"
                    // to="/tax-dispute-request/list-data"
                    to="/coming-soon?s=dispute"
                    className={styleHome["services-link"]}
                  >
                    <div
                      className="box d-flex justify-content-end gap-3 align-items-center border border-primary
                     rounded-4"
                    >
                      <img
                        src={dispute}
                        className={`${styleHome.serviceImg} pt-2 pb-2 ps-3 pe-3`}
                        alt="dispute"
                      />
                      <div className="flex-grow-1">
                        <h3 className="text-center mb-0">
                          إنهاء المنازعات الضريبية
                        </h3>
                      </div>
                    </div>
                  </Link>
                </div>

                <div className={`${styleHome.info} info mt-3`}>
                  <Link
                    id="support_button_home"
                    to="/support"
                    className={styleHome["services-link"]}
                  >
                    <div
                      className="box d-flex justify-content-end gap-3 align-items-center border border-primary
                     rounded-4"
                    >
                      <img
                        src={support}
                        width="110"
                        height="110"
                        className={`${styleHome.serviceImg} pt-2 pb-2 ps-3 pe-3`}
                        alt="support"
                      />
                      <div className="flex-grow-1">
                        <h3 className="text-center mb-0">الدعم الفني</h3>
                      </div>
                    </div>
                  </Link>
                </div>

                <div className={`${styleHome.info} info mt-3`}>
                  <Link
                    id="user_settings_button_home"
                    to="/user-settings"
                    className={styleHome["services-link"]}
                  >
                    <div
                      className="box d-flex justify-content-end gap-3 align-items-center border border-primary
                     rounded-4"
                    >
                      <img
                        src={manMask}
                        alt="user-icon"
                        width="100"
                        height="100"
                        className={`${styleHome.serviceImg} pt-2 pb-2 ps-3 pe-3`}
                      />
                      <div className="flex-grow-1">
                        <h3 className="text-center mb-0">إدارة المستخدم</h3>
                      </div>
                    </div>
                  </Link>
                </div>

                {!auth.isAuth ? (
                  <div className="text-center mt-lg-5 mt-4 mb-4">
                    <Link
                      to="/login"
                      id="login_button_home"
                      className={`${styleHome.login} fw-bolder text-primary h3`}
                    >
                      تسجيل الدخول
                    </Link>
                  </div>
                ) : (
                  <div className="text-center mt-5 mb-4">
                    <Link
                      id="logout_button_home"
                      onClick={handleLogout}
                      to=""
                      className={`${styleHome.login} fw-bolder text-primary h3`}
                    >
                      تسجيل خروج
                    </Link>
                  </div>
                )}
              </div>
            </div>
            <div className={styleHome.lottie_building}>
              <Lottie options={defaultOptions} />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Home;
